import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  iconButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  AppBar: {
    background: "linear-gradient(-45deg,#39249a,#e14e42)",
  },
}));

const NavBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar className={classes.AppBar} position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.iconButton}
            color="inherit"
            aria-label="menu"
          >
            <i class="fas fa-fingerprint"></i>
          </IconButton>
          <Typography variant="h6" className={classes.title}>
          Generator ID
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
};
export default NavBar;

